import { getQueryString } from 'UTILS/utils';

// 获取环境变量
// ENV: prod, beta, alpha
// pbENV: prod, (beta/pre/audit), alpha
export const getENV = () => {
  let checkURL = location.href.split('?')[0].split('#')[0];
  let env = getQueryString('env') || localStorage.getItem('_env_'); // 优先级最高
  let data = {
    // 默认正式服
    pbENV: 'prod',
    ENV: 'prod',
  };

  if (!env) {
    let regArr = /\/(beta|beta-tx|pre|pre-tx|audit|staging|prod|alpha)\//.exec(checkURL);

    if (regArr && regArr.length === 2) {
      env = regArr[1];
    } else {
      env = process.env.enviroment;
    }
  }

  if (/beta|beta-tx|pre|pre-tx|audit|staging|prod|alpha/.test(env)) {
    data = {
      pbENV: env,
      ENV: env || 'beta', // 判断prod,alpha，默认beta
    };
  }

  // 腾讯云环境
  // if (data['pbENV'].indexOf('-tx') !== -1) {
  //   data['pbENV'] = data['pbENV'].replace('-tx', '');
  // }

  return data;
};

const envData = getENV();
const envConf = {
  ...require(`./${process.env.project}.js`).default,
  ...require(`./${process.env.project}.${process.env.enviroment}.js`).default,
};
export { envData, envConf };
export default envConf;
